import Vue from 'vue'
import AdminConfirmDialog from '../components/AdminConfirmDialog.vue'

let instance = null

function getInstance() {
  if (!instance) {
    const Ctor = Vue.extend(AdminConfirmDialog)
    instance = new Ctor()
    instance.$mount(document.createElement('div'))
    document.body.appendChild(instance.$el)
  }
  return instance
}

/**
 * 统一确认弹窗（替代 Element MessageBox.$confirm）
 * @returns {Promise<boolean>}
 */
export function appConfirm(options = {}) {
  return getInstance().open(options)
}

export default appConfirm
